import { useLibrary } from './useLibrary'
import { useRoutes } from 'hookrouter'
import { routes } from '../components/routes'
import { useLanguage } from '../store/locale/hooks/useLanguage'
import { MenuType, useMenu } from './useMenu'
import { useTranslations } from './useTranslations'
import { useImages } from './useImages'
import { ILocalizedLanguage } from '../store/locale/types'
import { useMediaQuery, useTheme } from '@material-ui/core'

export const useLayout = () => {
  const { libraryRoutes, isLoaded } = useLibrary()
  const url = window.location.href
  const routeResult = useRoutes({ ...routes, ...libraryRoutes })
  const { language, availableLanguages, onLanguageChange } = useLanguage()
  const topMenuItems = useMenu(MenuType.Header)
  const menuItems = useMenu(MenuType.Main)
  const footerItems = useMenu(MenuType.Footer)
  const t = useTranslations()
  const { getImage } = useImages('header')
  const logo = getImage('logo')
  const { getImage: getCommonImage } = useImages('common')
  const notFound = getCommonImage('not-found')
  const languages = availableLanguages.map<ILocalizedLanguage>((language) => ({
    ...language,
    name: t(language.code)
  }))
  const theme = useTheme()
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('md'))

  return {
    routeResult,
    isLibraryRoutesLoaded: isLoaded,
    isLargeScreen,
    t,
    footerItems,
    notFound,
    menuProps: {
      logo,
      selectedLanguage: language,
      onSelectLanguage: onLanguageChange,
      languages,
      topMenuItems,
      menuItems
    },
    url,
    language
  }
}
